// extracted by mini-css-extract-plugin
module.exports = {"form":"google-integration-form_form__G6GAb","submit":"google-integration-form_submit__1ypBM"};